export const isContentfulRecord = (record?: { sys?: object }) => Boolean(record?.sys);
